import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-neutral-600 font-medium text-sm"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionTitle',
  props: {
    title: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    fontSmall: {
        type: Boolean,
        default: false,
    },
    cstmTitleClass: {
        type: String,
        default: null,
    }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", {
      class: _normalizeClass(["font-semibold mb-1", [__props.fontSmall ? 'md:text-xl text-base' : 'lg:text-2xl text-xl', __props.cstmTitleClass ]])
    }, _toDisplayString(__props.title), 3),
    (__props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})